module.exports = __webpack_public_path__ + "media/images/shared/suppliers/EURORICAMBI-bb6d2e7c5e9c65aeee8ef7e175ed8c49.jpg";